var app = require('../manager-module.js');

app.controller('tradingviewcontroller', ['$scope', '$http', function($scope, $http) {

  var root_path_magrela = "https://magrela.xyz";
  var root_path_calculadora = "http://calculadorabitcoin.com.br";



    $scope.magrela = root_path_magrela;


}]);



//////////////////
// WEBPACK FOOTER
// ./app/js/controllers/tradingviewcontroller.js
// module id = 211
// module chunks = 0